import { cx } from 'class-variance-authority';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Root: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={'w-screen h-full flex flex-1 items-center flex-col justify-center p-6'}>
      <div
        className={cx(
          'relative bg-white dark:bg-neutral-900 border border-neutral-900 dark:border-white px-8 py-9 rounded-3xl max-w-[35rem] sm:min-w-0 w-full overflow-hidden',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};

export const Header: React.FC<Props> = ({ children, className }) => {
  return <div className={cx('mb-6 gap-2', className)}>{children}</div>;
};

export const Content: React.FC<Props> = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

export const Footer: React.FC<Props> = ({ children, className }) => {
  return <div className={cx('mt-5', className)}>{children}</div>;
};

const AuthContainer = { Root, Header, Footer, Content };

export default AuthContainer;
